import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Card,
  CardContent,
  Chip,
  Divider
} from '@mui/material';
import {
  LocationOn,
  Email,
  Phone,
  Language,
  CalendarToday,
  Pets
} from '@mui/icons-material';

interface Shelter {
  id: string;
  name: string;
  description?: string;
  city: string;
  county: string;
  email?: string;
  phone?: string;
  website?: string;
  logo?: string;
  animal_count?: number;
  status: string;
  created_at: string;
}

interface ShelterOverviewProps {
  shelter: Shelter;
}

const ShelterOverview: React.FC<ShelterOverviewProps> = ({ shelter }) => {
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Despre {shelter.name}
      </Typography>
      
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={3}>
        {/* Informații principale */}
        <Box flex={2}>
          <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Descriere
            </Typography>
            <Typography variant="body1" paragraph>
              {shelter.description || 'Nu există descriere disponibilă pentru acest adapost.'}
            </Typography>
          </Paper>

          <Paper elevation={1} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Statistici
            </Typography>
            <Box display="flex" gap={2} flexWrap="wrap">
              <Chip
                icon={<Pets />}
                label={`${shelter.animal_count || 0} animale disponibile`}
                color="primary"
                variant="outlined"
              />
              <Chip
                icon={<CalendarToday />}
                label={`Activ din ${new Date(shelter.created_at).toLocaleDateString('ro-RO')}`}
                variant="outlined"
              />
            </Box>
          </Paper>
        </Box>

        {/* Informații de contact */}
        <Box flex={1}>
          <Paper elevation={1} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Informații de contact
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box display="flex" alignItems="center" gap={1}>
                <LocationOn color="action" />
                <Typography variant="body2">
                  {shelter.city}, {shelter.county}
                </Typography>
              </Box>
              
              {shelter.email && (
                <Box display="flex" alignItems="center" gap={1}>
                  <Email color="action" />
                  <Typography variant="body2">
                    {shelter.email}
                  </Typography>
                </Box>
              )}
              
              {shelter.phone && (
                <Box display="flex" alignItems="center" gap={1}>
                  <Phone color="action" />
                  <Typography variant="body2">
                    {shelter.phone}
                  </Typography>
                </Box>
              )}
              
              {shelter.website && (
                <Box display="flex" alignItems="center" gap={1}>
                  <Language color="action" />
                  <Typography 
                    variant="body2" 
                    component="a" 
                    href={shelter.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: 'primary.main', textDecoration: 'none' }}
                  >
                    {shelter.website}
                  </Typography>
                </Box>
              )}
            </Box>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default ShelterOverview;
